export const INFO : IImageSwitchingTabs = {
    tabs: [],
    footerHeadline: '',
    footerButtonText: '',
    footerButtonLink: '/',
    footerButtonExternalLink: false
}
